import { Controller } from "@hotwired/stimulus"

// Slides a drawer panel in on connect and back out on close, then clears the
// turbo-frame it lives in so the same frame can load a fresh drawer next time.
// Closes on backdrop click (wired in the markup) or Escape.
export default class extends Controller {
  static targets = ["panel"]

  connect() {
    requestAnimationFrame(() => this.panelTarget.classList.remove("translate-x-full"))
    this.onKeydown = (event) => { if (event.key === "Escape") this.close() }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.removeEventListener("keydown", this.onKeydown)
  }

  close(event) {
    if (event) event.preventDefault()
    this.panelTarget.classList.add("translate-x-full")
    setTimeout(() => this.element.remove(), 300)
  }
}
